import { render, staticRenderFns } from "./MultipleChoiceFeedback.vue?vue&type=template&id=86b1807a&scoped=true&"
import script from "./MultipleChoiceFeedback.vue?vue&type=script&lang=js&"
export * from "./MultipleChoiceFeedback.vue?vue&type=script&lang=js&"
import style0 from "./MultipleChoiceFeedback.vue?vue&type=style&index=0&id=86b1807a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86b1807a",
  null
  
)

component.options.__file = "MultipleChoiceFeedback.vue"
export default component.exports